const LOGO = { width: 400, height: 400 };
const COVER_IMAGE = { width: 1400, height: 540 };

export default {
  LOGO,
  COVER_IMAGE,
};
